import { Injectable } from '@angular/core';
import * as _ from 'lodash-es';

export function xformFileData(data: any) {

    return _.reduce(
        _.isObject(data) ? data : {},
        function(fd, value: any, key) {
            // RMT - There is no good way to mock FileList or File objects
            // This section won't be unit testable until we find a way.
            if (value instanceof FileList) {
                if (value.length == 1) {
                    fd.append(key, value[0]);
                } else {
                    _.each(value, function(file, index) {
                        fd.append(key + '_' + index, file);
                    });
                }
            } else {
                fd.append(key, value);
            }
            return fd;
        },new FormData()
    );
}